import { useEffect } from "react";

export const SITE_URL = "https://effectdeal.com";

const setMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Lightweight SEO head manager (no external dependency, React 19 safe).
 * Updates document title, meta description, canonical, OpenGraph + Twitter
 * tags and optional JSON-LD on client-side navigation. The static defaults in
 * public/index.html cover non-JS social scrapers for the homepage.
 */
export const Seo = ({
  title,
  description,
  path = "",
  image,
  type = "website",
  jsonLd,
}) => {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const img = image || `${SITE_URL}/og-image.png`;

    if (title) document.title = title;
    setMeta("name", "description", description);
    setLink("canonical", url);

    setMeta("property", "og:type", type);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    let ld = document.getElementById("seo-jsonld");
    if (jsonLdStr) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "seo-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = jsonLdStr;
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, path, image, type, jsonLdStr]);

  return null;
};

export default Seo;
